import apiClient from './api_client';

export type ConnectorState = {
    provider: string;
    descope_app_id: string;
    state: ConnectionState;
};

export enum ConnectionState {
    CONNECTED = 'connected',
    NOT_CONNECTED = 'not_connected',
    NEEDS_RECONNECT = 'needs_reconnect'
}

export const listMCPConnectors = async (
    tenantId: string
): Promise<ConnectorState[]> => {
    const response = await apiClient.get(
        `/mcp/connectors?tenant_id=${tenantId}`
    );
    return response.json();
};

/**
 * What happens when the agent wants to call one tool.
 *
 * `ASK` is the default for anything the provider did not annotate `readOnlyHint: true`,
 * so most write tools show it without anyone having chosen it.
 */
export enum ToolDecision {
    ALLOW = 'allow',
    ASK = 'ask',
    DENY = 'deny'
}

export type ToolPolicy = {
    name: string;
    /** The provider annotated it read-only. Groups the list; does not gate the call. */
    read_only: boolean;
    decision: ToolDecision;
};

export const listConnectorTools = async (
    tenantId: string,
    provider: string
): Promise<ToolPolicy[]> => {
    const response = await apiClient.get(
        `/mcp/connectors/${provider}/tools?tenant_id=${tenantId}`
    );
    return response.json();
};

/** One tool per call: there is no bulk route, and that is deliberate. */
export const setConnectorToolDecision = async (
    tenantId: string,
    provider: string,
    toolName: string,
    decision: ToolDecision
): Promise<void> => {
    await apiClient.put(
        `/mcp/connectors/${provider}/tools/${toolName}/decision?tenant_id=${tenantId}`,
        { decision }
    );
};

export const disconnectMCPConnector = async (
    tenantId: string,
    provider: string
): Promise<void> => {
    const url = `/mcp/connectors/${provider}/connection?tenant_id=${tenantId}`;
    await apiClient.delete(url, {});
};
